export const FK_RESULT_ID = '6fc545b9-69ae-4ef8-8960-f8d05c35e14e';
export const FK_Q3_A1_ID = '6c27e679-f875-4d62-ae31-c8f0bbedec7e';
export const FK_Q3_A2_ID = '07f70386-10ba-4d60-9669-57a71abb649f';

export const PK_RESULT_ID = 'f1c00fb7-36ed-4375-993d-db1e6e00666e';
export const PK_Q1_A1_ID = '32cd135d-1987-4c2d-9a6c-064d8cb18047';
export const PK_Q1_A2_ID = '8fc85b2f-12d6-49b7-8734-f1bafdcb51cd';
export const PK_Q3_A3_ID = '27bc0001-d931-4f32-8e60-58c7b9b84d52';
